import {Injectable} from '@angular/core';
import {Resolve} from '@angular/router';
import {Observable} from 'rxjs/Observable';
import {GroupRight} from '../models/group-right';
import {GroupRightService} from '../services/group-right.service';

@Injectable()

/**
 * GroupRightsResolver resolves request to get the current authenticated users' organisation
 */
export class GroupRightsResolver implements Resolve<GroupRight[]>
{
	/**
	 * GroupRightsResolver constructor
	 *
	 * @param {GroupRightService} groupRightService
	 */
	constructor(private groupRightService: GroupRightService)
	{
	}

	/**
	 * Provides data to a route
	 *
	 * @returns {Observable<GroupRight[]>}
	 */
	resolve(): Observable<GroupRight[]>
	{
		return this.groupRightService.getGroupRights();
	}
}



// WEBPACK FOOTER //
// ./src/app/resolvers/group-rights.resolves.ts